import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { propsUserData, propsUserState } from './interfaces';

const initialState: propsUserState = {
  data: {
    id: '',
    userId: '',
    active: false,
    fullName: '',
    role: 'user',
    userType: 'PF',
    contact: { email: '', phone: '' },
    farm: {},
  },
  loading: false,
  update: false,
  error: false,
  success: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userRequest: (state) => {
      state.loading = true;
    },
    userUpdate: (state) => {
      state.update = true;
    },
    userSuccess: (state) => {
      state.success = true;
      state.error = false;
      state.loading = false;
      state.update = false;
    },
    userFailure: (state) => {
      state.success = false;
      state.loading = false;
      state.update = false;
      state.error = true;
    },
    userSetData: (state, action: PayloadAction<Partial<propsUserData>>) => {
      state.data = { ...state.data, ...action.payload };
      state.success = true;
      state.loading = false;
      state.error = false;
      state.update = false;
    },
    clearUser: () => initialState,
  },
});

export const {
  userRequest,
  userSuccess,
  userFailure,
  userSetData,
  clearUser,
  userUpdate,
} = userSlice.actions;
export default userSlice.reducer;
